import { useState, useEffect } from 'react';
import { Grid } from '@mui/material';
import { toast } from '@cincoders/cinnamon';
import Manual from '../../components/Manual/index';
import TableProcessesStatistics from '../../components/TableProcessesStatistics';
import { ProcessesStatisticsService } from '../../services/ProcessesStatisticsService';
import { ConcludedCard, DelayCard, ExpireCard, InProgressCard } from '../../components/Card';
import { HomeContainer } from './styles';
import { Statistics } from '../../types/ProcessStatistics.d';

const Home: React.FC = () => {
  const [statistics, setStatistics] = useState<Statistics>({} as Statistics);
  const [loading, setLoading] = useState<boolean>(true);

  async function generalStatistics() {
    try {
      const response = await ProcessesStatisticsService.getGeneralStatistics();
      setStatistics(response.data);
    } catch {
      toast.error('Não foi possível carregar estatísticas. Tente novamente mais tarde.');
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    generalStatistics();
  }, []);

  return (
    <>
      <Manual
        visible={false}
        manualTitle='Manual SIPAC'
        itemsManual={[
          {
            itemTitle: 'Favoritar',
            itemBody:
              'Favorita um processo com todas suas informações, ' +
              'uma vez favoritado serão exibidos como primeiros da tabela',
          },
          {
            itemTitle: 'Ordenação',
            itemBody: 'A tabela pode ser ordenada clicando na seta, localizada ao lado direito dos tópicos da tabela',
          },
          {
            itemTitle: 'Nº do processo',
            itemBody: 'Exibe informação completa do número do processo',
          },
          {
            itemTitle: 'Tipo',
            itemBody: 'Tipos de convênios cadastrados na aba “Tipo de processos” no menu',
          },
          {
            itemTitle: 'Progresso Unidade',
            itemBody: 'Tempo decorrido a partir do momento em que o processo foi recebido na unidade atual',
          },
          {
            itemTitle: 'Progresso Geral',
            itemBody:
              'Exibe a porcentagem do progresso com base no percurso de todas as ' +
              'unidades das quais o processo deve transitar',
          },
          {
            itemTitle: 'Unidade Atual',
            itemBody: 'Unidade atual do qual processo transita',
          },
          {
            itemTitle: 'Previsão de término',
            itemBody:
              'Para edição de processo, é necessário inserir um número de processo válido, ' +
              'o nome do processo, assim como seu status, serão exibidos juntamente com as ' +
              'opções de parâmetros (extensão, inovação e pesquisa) de acordo com o projeto buscado. ' +
              'Haverá também a opção de troca do tipo de processo. ' +
              'Para que todas as informações sejam alteradas, clique no botão “salvar” em azul, ' +
              'no canto inferior direito do formulário',
          },
        ]}
      />

      <HomeContainer>
        <Grid
          container
          marginTop={{ xs: 1, sm: 1, md: 1, lg: 1 }}
          marginBottom={3}
          justifyContent='center'
          spacing={{ xs: 1, sm: 1, md: 1 }}
          columns={{ xs: 2.1, sm: 4.1, md: 8.1, lg: 12.1, xl: 4 }}
        >
          <InProgressCard value={statistics.processInProgress} loading={loading} />
          <DelayCard value={statistics.overdueProcess} loading={loading} />
          <ConcludedCard value={statistics.concludedProcess} loading={loading} />
          <ExpireCard value={statistics.covenantsCloseToExpire} loading={loading} />
        </Grid>
        <TableProcessesStatistics />
      </HomeContainer>
    </>
  );
};

export default Home;
